import React, { useEffect, useRef, useState } from "react";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import { VALIDATE } from "../utils/Validators";
import Checkbox from "../ui/Checkbox";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { kbdEvent, playSounds } from "../utils/Utils";
import TextButton from "../ui/TextButton";
import Float from "../ui/Float";
import Button from "../ui/Button";
import Cookies from 'js-cookie';

export default function ReconciliationSounds(props) {


    const { callback = () => { }, route = "", term = "", type = "", supplier = "", bisac = "" } = props;
    const refs = useRef([]);
    const [index, setIndex] = useState("play_sounds");

    const sounds_json = Cookies.get("rec_sounds");
    const sounds = sounds_json ? JSON.parse(sounds_json) : {};

    const [tabs, setTabs] = useState([
        { key: "play_sounds", value: sounds.play_sounds ?? true },
        { key: "play_scanned", value: sounds.play_scanned ?? true },
        { key: "play_short", value: sounds.play_short ?? true },
        { key: "play_even", value: sounds.play_even ?? true },
        { key: "play_over", value: sounds.play_over ?? true },
        { key: "play_not_found", value: sounds.play_not_found ?? true },
        { key: "play_months", value: sounds.play_months ?? 0 },
    ])


    const playSound = () => {
        if (index !== "play_sounds") {
            playSounds([index]);
        }

    }

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value;
    }

    const sounds_enabled = getVal("play_sounds");

    const editProps = (index) => ({

        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => { update(index, e); if (e) { playSounds([index]) } }
    });


    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const save = () => {
        const tabsObject = tabs.reduce((acc, { key, value }) => {
            acc[key] = value;
            return acc;
        }, {});
        Cookies.set('rec_sounds', JSON.stringify(tabsObject), { expires: 7 });
        callback(true);
    }

    const onEnter = () => {
        if (index && index !== "play_months") {
            let _v = getVal(index);
            update(index, !_v);
            if (!_v) { playSounds([index]); }

        }
    }

    // Keyboard Events
    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            { key: KBD.PAGE_UP, action: (e) => { playSound() } },
            { key: KBD.ENTER, action: (e) => { onEnter() } },
            { key: KBD.PAGE_DOWN, action: (e) => { save() } }
        ];
        const cleanup = listen(route, actions, (e) => { }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN], [], []);
        return cleanup;
    }, [index, update]);


    return (
        <>
            <div style={{ "width": "390px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={210}>Enable sounds</Label><Divider vertical />
                    <Checkbox value={tabs.find(item => item.key === "play_sounds").value} {...editProps("play_sounds")} ></Checkbox>
                </Space>

                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={210}>Item is scanned</Label><Divider vertical />
                    <Checkbox className={(sounds_enabled) ? "" : "dim"} value={tabs.find(item => item.key === "play_scanned").value} {...editProps("play_scanned")} ></Checkbox>
                </Space>

                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={210}>Previous item's count was short</Label><Divider vertical />
                    <Checkbox className={(sounds_enabled) ? "" : "dim"} value={tabs.find(item => item.key === "play_short").value} {...editProps("play_short")} ></Checkbox>
                </Space>

                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={210}>Current item count reconciles</Label><Divider vertical />
                    <Checkbox className={(sounds_enabled) ? "" : "dim"} value={tabs.find(item => item.key === "play_even").value} {...editProps("play_even")} ></Checkbox>
                </Space>

                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={210}>Current item count is over</Label><Divider vertical />
                    <Checkbox className={(sounds_enabled) ? "" : "dim"} value={tabs.find(item => item.key === "play_over").value} {...editProps("play_over")} ></Checkbox>
                </Space>

                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={210}>Item scanned is not in Inventory </Label><Divider vertical />
                    <Checkbox className={(sounds_enabled) ? "" : "dim"} value={tabs.find(item => item.key === "play_not_found").value} {...editProps("play_not_found")} ></Checkbox>
                </Space>

                <div className="shim" />

                <Label style={{ "textAlign": "center" }} >Item scanned is over  <Input {...editProps("play_months")} maxLength={2} number autoselect parse={(e) => { if (e > 24) { return 24 } else { return e } }} placeholder="" width={25} edit value={getVal("play_months")} /> months old </Label>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Divider />
                <div className="shim" />
                <Float>
                    <div></div>
                    <Space>
                        <Button onClick={() => kbdEvent(KBD.ESCAPE)} kbd={KBD.ESCAPE}>Cancel</Button>
                        <Button onClick={() => kbdEvent(KBD.PAGE_DOWN)} type="secondary" kbd={KBD.PAGE_DOWN}>Save</Button>
                    </Space>
                </Float>
            </div>
        </>
    )
}